import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import distributionApi from 'services/api/distribution';
import ReleasesList from '../../components/ReleasesList';
import { StyledCircularProgress, StyledTypography } from './styled';

const AllReleases = () => {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const { data, isLoading, isFetching, isError } =
    distributionApi.useGetAllReleasesQuery(page);

  if (isLoading || isError) {
    return <StyledCircularProgress />;
  }

  if (!data?.releases.length) {
    return <StyledTypography>{t('distribution:emptyState')}</StyledTypography>;
  }

  return (
    <ReleasesList
      data={data}
      isFetching={isFetching}
      onLoadMore={() => setPage(page + 1)}
    />
  );
};

export default AllReleases;
